import ManageHeader from '@utils/manageHeader';
import WindowState from '@utils/windowState';
import observeStickyElement from '@utils/manageStickyElement';

const manageOverlay = (overlayOpen, overlayDetailOpen, headerState = true) => {
  if (!headerState) {
    overlayOpen.classList.remove('top-0');
    overlayOpen.classList.remove('without-header');
    overlayDetailOpen.classList.remove('top-0');
    overlayDetailOpen.classList.remove('without-header');
  } else {
    overlayOpen.classList.add('top-0');
    overlayOpen.classList.add('without-header');
    overlayDetailOpen.classList.add('top-0');
    overlayDetailOpen.classList.add('without-header');
  }
};

// managing changing design on scroll sticky
const initSticky = () => {
  // config
  const ELEMENT_CLASS = '.ButtonsFilter';
  const ELEMENT_CHILD_CLASS = '.btn--secondary';
  const NOT_STICKY_CLASS = 'notSticky';

  const header = document.querySelector('#Header');
  const buttons = document.querySelector(ELEMENT_CLASS);
  const overlayOpen = document.querySelector('.OverlayFilters');
  const overlayDetailOpen = document.querySelector('.OverlayDetails');

  if (buttons) {
    // When scroll goes up, toggle notSticky
    const manageHeader = ManageHeader(
      ELEMENT_CLASS,
      NOT_STICKY_CLASS,
      'active',
      () => {
        if (
          overlayOpen &&
          overlayDetailOpen &&
          !buttons.classList.contains('active') &&
          header.classList.contains(NOT_STICKY_CLASS)
        ) {
          manageOverlay(overlayOpen, overlayDetailOpen, true);
        } else {
          manageOverlay(overlayOpen, overlayDetailOpen, false);
        }
      }
    );

    const el = document.querySelector(ELEMENT_CLASS);

    observeStickyElement(el, 'active', (e, IS_STUCK) => {
      // retrieve background of the component
      const { CURRENT_BACKGROUND_COLOR, CURRENT_CHILD_BACKGROUND_COLOR } =
        window;

      // split to toggle them later
      const classList = CURRENT_CHILD_BACKGROUND_COLOR.split(' ');

      if (WindowState.TABLET_STATE.get()) return;

      // toggle colors and background-color
      e.target.classList.toggle(CURRENT_BACKGROUND_COLOR, IS_STUCK);

      // toggle button background and color
      el.querySelectorAll(ELEMENT_CHILD_CLASS).forEach((child) => {
        child.classList.toggle(classList[0], IS_STUCK);
        child.classList.toggle(classList[1], IS_STUCK);
        child.classList.toggle('text-white', IS_STUCK);
      });

      if (
        overlayOpen &&
        overlayDetailOpen &&
        document.querySelector(`#Header.${NOT_STICKY_CLASS}`)
      ) {
        manageOverlay(overlayOpen, overlayDetailOpen, false);
      }
    });
    document.addEventListener('scroll', manageHeader);
  }
};

const ButtonsFilter = () => {
  initSticky();
  initComparator();
};

async function initComparator() {
  const node = document.getElementById('product-comparator');

  if (node) {
    const { default: Comparator } = await import('./Comparator');
    const { default: React } = await import('react');
    const { default: ReactDOM } = await import('react-dom');

    ReactDOM.render(<Comparator />, node);
  }
}

export default ButtonsFilter;
